import { Outlet, Link } from 'react-router-dom'
import ErrorBoundary from '@/components/layout/ErrorBoundary'
export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-midnight flex flex-col">
      <div className="flex justify-center pt-8 mb-6">
        <Link to="/" className="flex flex-col items-center gap-2 group">
          <img
            src="/FinalLogo.png"
            alt="Illuminate Faith"
            className="h-14 w-auto rounded-lg"
            style={{ clipPath: 'inset(2% round 6px)' }}
          />
          <span className="font-heading text-gold text-xl font-bold group-hover:text-gold-light transition-colors">
            Illuminate Faith
          </span>
        </Link>
      </div>
      {/* Zone-level ErrorBoundary (FE-029) — a Login/Onboarding crash
          doesn't whitescreen the brand mark; user can still see they're
          on Illuminate Faith and refresh. */}
      <main id="main-content" className="flex-1 flex items-start justify-center px-4 pb-12">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  )
}
